import { useSelector } from 'react-redux';

import {
  loginCurrentStepSelector,
  onboardingCurrentStepSelector,
} from '»components/Auth';
import { getActiveMenuItemSelector } from '»components/Menus';

export const useCurrentPage = (currentRoute) => {
  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const onboardingCurrentStep = useSelector(onboardingCurrentStepSelector);
  const loginCurrentStep = useSelector(loginCurrentStepSelector);

  const isLandingPage =
    activeMenuItem === 'LANDING_PAGE' && currentRoute === '/';
  const isLoginPage = activeMenuItem === 'LOGIN' && currentRoute === '/Login';
  const isOnboardingPage =
    activeMenuItem === 'ONBOARDING' && currentRoute === '/Onboarding';

  return {
    isProofPreviewPage:
      activeMenuItem === 'TRADING:PRIMARY:PROOF' ||
      activeMenuItem === 'TRADING:BOLSA:PROOF' ||
      activeMenuItem === 'TRADING:BOLSA:DETAILS:PROOF' ||
      activeMenuItem === 'TRADING:FUNDS:PROOF' ||
      activeMenuItem === 'TRADING:FUNDS:DETAILS:PROOF' ||
      activeMenuItem === 'MARKET:PRIMARY:PROOF' ||
      activeMenuItem === 'MARKET:BOLSA:PROOF' ||
      activeMenuItem === 'MARKET:BOLSA:DETAILS:PROOF' ||
      activeMenuItem === 'MARKET:FUNDS:PROOF' ||
      activeMenuItem === 'MARKET:FUNDS:DETAILS:PROOF',
    isLandingPage,
    isNoAuthFormPage: isLoginPage || isOnboardingPage,
    isLoginPage,
    isOnboardingPage,
    isFunds:
      activeMenuItem === 'MARKET:FUNDS' ||
      activeMenuItem === 'MARKET:FUNDS:DETAILS',
    isFundsListPage: activeMenuItem === 'MARKET:FUNDS',
    isFundsDetailsPage: activeMenuItem === 'MARKET:FUNDS:DETAILS',
    isFundsOrders:
      activeMenuItem === 'TRADING:FUNDS' ||
      activeMenuItem === 'TRADING:FUNDS:DETAILS' ||
      activeMenuItem === 'TRADING:FUNDS:PROOF' ||
      activeMenuItem === 'TRADING:FUNDS:DETAILS:PROOF',
    isFundsOrdersDetailsPage: activeMenuItem === 'TRADING:FUNDS:DETAILS',
    isStockExchangeOrdersDetailsPage:
      activeMenuItem === 'TRADING:BOLSA:DETAILS',
    isTradingPrimaryPage: activeMenuItem === 'TRADING:PRIMARY',
    isMarketPrimaryPage: activeMenuItem === 'MARKET:PRIMARY',
    isMarketStockExchangePage: activeMenuItem === 'MARKET:BOLSA',
    isMarketStockExchangeDetailsPage: activeMenuItem === 'MARKET:BOLSA:DETAILS',
    isMarketStockExchangeOrders:
      activeMenuItem === 'TRADING:BOLSA' ||
      activeMenuItem === 'TRADING:BOLSA:DETAILS' ||
      activeMenuItem === 'TRADING:BOLSA:PROOF' ||
      activeMenuItem === 'TRADING:BOLSA:DETAILS:PROOF',
    isMarketStockExchangeOrdersList: activeMenuItem === 'TRADING:BOLSA',
    isOnboardingStinvestFirstStep:
      isOnboardingPage && onboardingCurrentStep === 0,
    isOnboardingCreateAccountStep:
      isOnboardingPage && onboardingCurrentStep === 1,
    isOnboardingInitialOtpStep: isOnboardingPage && onboardingCurrentStep === 2,
    isOnboardingMainFormStep: isOnboardingPage && onboardingCurrentStep === 3,
    isOnboardingAdvancedSteps: isOnboardingPage && onboardingCurrentStep > 1,
    isOnboardingQuestionnaire: isOnboardingPage && onboardingCurrentStep === 6,
    isOnboardingDocumentAcceptance:
      isOnboardingPage && onboardingCurrentStep === 7,
    isOnboardingDocumentsAttach:
      isOnboardingPage && onboardingCurrentStep === 8,
    isLoginValidationStep: isLoginPage && loginCurrentStep === 1,
    isSettingsQuestionnaire:
      activeMenuItem === 'GENERIC:SETTINGS:QUESTIONNAIRE',
    isSettingsMainPage:
      activeMenuItem === 'SETTINGS' || activeMenuItem === 'GENERIC:SETTINGS',
    isWalletPage: activeMenuItem === 'WALLET',
  };
};
